<div *ngIf="isPageReady" class="flex flex-col h-full">
  <app-ag-grid
    [gridOptions]="gridOptions"
    [rowData]="previewItems"
    class="flex-1 min-h-0"
  ></app-ag-grid>

  <div class="flex justify-between items-center p-3 border-t">
    <div class="text-sm text-gray-500">
      Selected: {{ selectedProductCount.toLocaleString() }} products across {{ selectedRowCount }} product types
    </div>
    <div class="flex gap-2">
      <button pButton type="button" class="p-button-text" (click)="onCancel()">
        <span>Cancel</span>
      </button>
      <button pButton type="button" class="p-button-raised" [disabled]="selectedRowCount === 0" (click)="onApply()">
        <span>Apply</span>
      </button>
    </div>
  </div>
</div>
